document.addEventListener('DOMContentLoaded', function() {
  var loadSvgDetails = [
    {
      'selector': ['#shopify-section-template--24009034531143__173298802648394f84 #shopify-block-kehio_editor_app_block_faq_xiFMrp'],
      'svg_url':'https://cdn.shopify.com/s/files/1/0863/7635/0023/files/F_Gradient_White.svg?v=1733046094',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '0',
        'width': '40%',
        'z-index': '-1',
        'opacity': '0.5',
        'class': 'svg_bg_3',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '40%'
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
    		'width': '40%'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
    		'width': '40%'
          },
          '(min-width: 1440px)': {
    		'width': '40%'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21471196152107__1686159157bc3d096d','#shopify-section-template--22578758320427__16900405694738ec8e','#shopify-section-template--22578784600363__16900357188b2b8cdb'],
      'svg_url':'https://cdn.shopify.com/s/files/1/0741/2829/4187/files/K_Gradient_Orange.svg?v=1699536451',
      'css': {
        'position': 'absolute',
        'right': '0',
        'top': '0',
        'z-index': '0',
        'width': '100%',
        'opacity': '0.5',
        'class': 'svg_bg_4',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
  ];

  var resizeTimeout;//

  var resizeTimeout;

  for (var i = 0; i < loadSvgDetails.length; i++) {
    
    var selectors = loadSvgDetails[i].selector;
    var svgType = loadSvgDetails[i].svg;
    var cssProperties = loadSvgDetails[i].css;
    var mediaQueries = cssProperties.mediaQueries;
    var container = document.createElement('div');
    if(typeof loadSvgDetails[i].svg_url !== "undefined" && loadSvgDetails[i].svg_url != ''){
      var innerHtmlToAdd = '<img alt src="'+loadSvgDetails[i].svg_url+'" >';
    }else{
      var innerHtmlToAdd = svgData[svgType]
    }
    for (var s = 0; s < selectors.length; s++) {
      var selector = selectors[s];
      var element = document.querySelector(selector);
      if (element) {
        
        container.innerHTML = innerHtmlToAdd;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('dfredfd_container');
        container.classList.add(cssProperties.class);
        container.classList.add(cssProperties.class+'_'+s);
        container.classList.add('svg_bg_wrap');
        container.classList.add('fade_up_animate');
        //container.setAttribute('data-aos','fade-up');
        //container.setAttribute('data-aos-once','false');
       // if (window.scrollY === 0) {
         // container.setAttribute('data-aos-offset', '100');
       //   }
  
        applyCSSProperties(container, cssProperties);
  
        for (var mqQuery in mediaQueries) {
          var mqCSSProperties = mediaQueries[mqQuery];
  
          var mediaQueryList = window.matchMedia(mqQuery);
          mediaQueryList.addListener(createMediaQueryListener(container, mqCSSProperties));
  
          if (mediaQueryList.matches) {
            applyCSSProperties(container, mqCSSProperties);
          }
        }
        handleScroll();
        //Initialize AOS with desired options
        // AOS.init({
        //   duration: 1000,
        //   delay: 200,
        //   easing: 'ease-in-out',
        //  // data-aos-once
        //   // Add more options as needed
        // });
      } else {
        //console.log('Element with selector:', selector, ' not found.');
      }
    }
  }

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      for (var i = 0; i < loadSvgDetails.length; i++) {
        var selectors = loadSvgDetails[i].selector;
        
        var mediaQueries = loadSvgDetails[i].css.mediaQueries;
        for (var s = 0; s < selectors.length; s++) {
          var selector = selectors[s];
          
          var element = document.querySelector(selector);
  
          if (element) {
          //var container = element.querySelector('> .' + loadSvgDetails[i].css.class);
         // var childElements = Array.from(element.children);
          var container = document.querySelector(selector +' > .'+loadSvgDetails[i].css.class);

          for (var mqQuery in mediaQueries) {
            var mqCSSProperties = mediaQueries[mqQuery];
            var mediaQueryList = window.matchMedia(mqQuery);

            if (mediaQueryList.matches) {
              applyCSSProperties(container, mqCSSProperties);
            }
          }
        }
        }
      }
    }, 200); // Adjust the timeout duration as needed
  });
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        
        // Check if the top of the element has started entering the viewport from the bottom
        return rect.top >= 0 && rect.top < windowHeight;
    }
    
    function handleScroll() {
        const fadeUpElements = document.querySelectorAll('.fade_up_animate:not(.animated)');  // Select elements that are not yet visible
        //console.log(fadeUpElements.length)
        fadeUpElements.forEach(element => {
            if (isInViewport(element)) {
                element.classList.add('animated');
            }
        });
    }
    
    window.addEventListener('scroll', handleScroll);

  function createMediaQueryListener(element, properties) {
    return function(mql) {
      if (mql.matches) {
        applyCSSProperties(element, properties);
      }
    };
  }

  function applyCSSProperties(element, properties) {
    for (var property in properties) {
      if (property === 'class') {
        element.classList.add(properties[property]);
      } else {
        element.style[property] = properties[property];
      }
    }
  }
  var buttons = document.querySelectorAll('a[href="#discuteravecunexpert"]');

    // Iterate over the selected elements and bind the click event handler
    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        // Code to execute when the button is clicked
        event.preventDefault();
        toggleDemoRequestForm();
        // Additional code...
      });
    });
    var imageSVG = '<?xml version="1.0" encoding="UTF-8"?><svg id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 194.04"><defs><style>.cls-1{fill:#e94408;}</style></defs><g id="Calque_2-2"><path class="cls-1" d="M89.45,21.56l-1.04-7.9-7.4.97,1.04,7.9-5.7.75-2.73-20.81,5.7-.75,1.03,7.84,7.4-.97-1.03-7.84,5.7-.75,2.73,20.81-5.7.75Z"/><path class="cls-1" d="M110.29,1.56c5.35.77,7.76,3.6,7.08,8.3-.67,4.69-3.78,6.74-9.13,5.98l-3.63-.52-.93,6.51-5.7-.81L100.97.23l9.33,1.33ZM108.69,10.72c1.85.26,2.72-.25,2.92-1.69.21-1.44-.49-2.18-2.33-2.44l-3.35-.48-.59,4.13,3.35.48Z"/><path class="cls-1" d="M128.51,25.71l-7.78-3.19-2.16,2.36-5.56-2.28,15.91-16.16,5.18,2.12v22.68s-5.71-2.34-5.71-2.34l.11-3.2ZM128.9,13.6l-4.67,5.16,4.45,1.82.29-6.95-.06-.02Z"/><path class="cls-1" d="M159.58,52.95c-1.43,1.04-3.29.74-4.33-.69-1.04-1.43-.74-3.29.69-4.33,1.43-1.04,3.29-.74,4.33.69,1.04,1.43.74,3.29-.69,4.33Z"/><path class="cls-1" d="M166.68,74.62l7.52-2.63-2.46-7.04-7.52,2.63-1.9-5.43,19.82-6.92,1.9,5.43-7.46,2.6,2.46,7.04,7.46-2.6,1.9,5.43-19.82,6.92-1.9-5.43Z"/><path class="cls-1" d="M182.57,95.68l-4.67.31-.52-7.89-3,.2.67,10.16-5.11.34-1.05-15.9,20.95-1.38,1.05,15.9-5.11.34-.67-10.16-3.06.2.52,7.89ZM197.65,89.86l.35,5.27-5.7-3.74-.3-4.58,5.65,3.05Z"/><path class="cls-1" d="M168.77,106.73l1.08-5.65,20.62,3.94-1.8,9.41c-1.02,5.31-3.9,7.59-8.5,6.71-3.23-.62-5.11-2.39-5.57-5.22l-8.21,3.23,1.26-6.62,7.42-2.44.4-2.08-6.71-1.28ZM179.84,112.49c-.34,1.8.1,2.69,1.43,2.95s2.07-.41,2.42-2.21l.67-3.51-3.85-.74-.67,3.51Z"/><path class="cls-1" d="M162.28,134.22l3.83-7.49-2.17-2.35,2.74-5.35,14.77,17.22-2.55,4.98-22.61-1.9,2.81-5.49,3.18.38ZM174.31,135.62l-4.75-5.09-2.19,4.28,6.91.87.03-.06Z"/><path class="cls-1" d="M150.35,158.58c-4.6-4.24-4.78-8.57-.56-13.15,4.18-4.53,8.47-4.66,13.07-.42l8.81,8.12-3.9,4.23-8.51-7.84c-2.28-2.1-4.19-2.27-5.81-.5-1.63,1.77-1.31,3.66.97,5.76l8.51,7.84-3.77,4.09-8.81-8.12Z"/><path class="cls-1" d="M141.68,153.85l11.41,17.62-4.83,3.13-8.63-13.32-8.17,5.29-2.78-4.3,13-8.42Z"/><path class="cls-1" d="M119.99,165.5l5.35-2.11,5.84,14.76,5.44-2.15,1.88,4.76-16.17,6.39-1.88-4.76,5.38-2.13-5.83-14.76Z"/><path class="cls-1" d="M97.98,190.56c-5.4.21-8.28-2.14-8.47-6.88-.19-4.74,2.5-7.31,7.9-7.52l3.66-.14-.26-6.57,5.75-.22.82,20.98-9.42.37ZM97.91,181.26c-1.86.07-2.63.74-2.57,2.19.06,1.45.87,2.06,2.74,1.98l3.38-.13-.16-4.17-3.38.13Z"/><path class="cls-1" d="M83.98,189.93l-5.69-.86,3.14-20.75,5.69.86-3.14,20.75Z"/><path class="cls-1" d="M61.11,175.55l1.55-4.42,7.46,2.61.99-2.83-9.61-3.36,1.69-4.83,15.04,5.27-6.94,19.81-15.04-5.27,1.69-4.83,9.61,3.36,1.01-2.89-7.46-2.61ZM67.23,194.04l-4.98-1.74-1.43-6.26,4.33,1.51,2.08,6.49Z"/><path class="cls-1" d="M36.59,169.27l3.44-5.19.21.14c.14,2.03,1.31,3.86,3.37,5.22,2.9,1.92,6.04,1.3,7.94-1.57,1.9-2.87,1.24-6-1.66-7.92-2.06-1.36-4.21-1.72-6.12-1.06l-.21-.14,3.44-5.19c1.94.11,3.54.67,5.96,2.28,5.62,3.71,6.94,9.97,3.45,15.24-3.49,5.27-9.76,6.51-15.38,2.79-2.43-1.6-3.57-2.85-4.43-4.6Z"/><path class="cls-1" d="M27.25,149.65l3.46-3.16,5.33,5.84,2.22-2.03-6.86-7.52,3.78-3.45,10.74,11.77-15.51,14.15-10.74-11.77,3.78-3.45,6.86,7.52,2.27-2.07-5.33-5.84Z"/><path class="cls-1" d="M9.49,134.21l5.16-2.82.12.22c-.58,1.9-.21,4.37,1.03,6.64.94,1.72,1.94,2.36,2.91,1.83.8-.44.8-1.3-.25-3.75-2.13-4.96-1.52-7.74,2.17-9.75,3.83-2.09,7.45-.53,10.11,4.35,1.7,3.11,2.45,5.61,2.28,7.61l-5.16,2.82-.12-.22c.48-2.49.03-5.24-1.28-7.62-1.04-1.92-2-2.55-3-2-.8.44-.81,1.34.28,3.81,2.17,4.9,1.56,7.68-2.02,9.64-3.89,2.12-7.68.51-10.36-4.4-1.23-2.25-2-4.85-1.88-6.36Z"/><path class="cls-1" d="M18.59,102.49l1.2,8.33,3.13.67.86,5.95-22.01-5.52-.8-5.54,19.56-11.51.88,6.1-2.82,1.52ZM7.96,108.31l6.82,1.41-.69-4.76-6.14,3.28v.06Z"/><path class="cls-1" d="M14.22,75.74c6.21.79,8.86,4.22,8.08,10.4-.78,6.11-4.2,8.71-10.41,7.92l-11.88-1.51.73-5.71,11.48,1.46c3.07.39,4.73-.58,5.03-2.96.3-2.38-1.05-3.73-4.13-4.13l-11.48-1.46.7-5.52,11.88,1.51Z"/><path class="cls-1" d="M27.87,65.01l-2.16,5.33-14.71-5.96-2.2,5.42-4.75-1.92,6.53-16.12,4.75,1.92-2.17,5.36,14.71,5.96Z"/><path class="cls-1" d="M34.93,35.41c5.03,3.84,5.81,10.2,1.86,15.38-3.95,5.18-10.3,6.1-15.33,2.26s-5.81-10.2-1.86-15.38c3.95-5.18,10.3-6.1,15.33-2.26ZM25,48.43c2.69,2.05,5.81,1.77,7.73-.75,1.92-2.51,1.37-5.6-1.32-7.65s-5.81-1.77-7.73.74c-1.92,2.51-1.37,5.6,1.32,7.65Z"/><path class="cls-1" d="M46.95,35.8c1.17,1.33,1.06,3.2-.27,4.37s-3.2,1.06-4.37-.27-1.06-3.2.27-4.37,3.2-1.06,4.37.27Z"/></g></svg>';
    var imageSelector = [
      {'selector':'#faq_body_4466_info_2_1_1 > div','type':'left_svg'},
      {'selector':'#faq_body_4434_info_1_1_1 > div','type':'right_svg'},
      {'selector':'#faq_body_4013_info_10_1_1 > div','type':'right_svg'},
      {'selector':'#faq_body_459_info_7_1_1 > div','type':'right_svg'},
      {'selector':'#faq_body_263_info_6_1_2 > div','type':'right_svg'},
      {'selector':'#faq_body_5187_info_5_1_1 > div','type':'right_svg'},
      {'selector':'#faq_body_5189_info_6_1_1 > div','type':'left_svg'}
    ];
    
    for (var s = 0; s < imageSelector.length; s++) {
      var selectorImg = imageSelector[s];
     // console.log('selector',selectorImg);
      var element = document.querySelector(selectorImg.selector);
      if (element) {
        var container = document.createElement('div');
        container.innerHTML = imageSVG;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('image_svg_contain');
        container.classList.add('image_svg_wrap');
        container.classList.add(imageSelector[s].type);
      }
    }
});
